import { render, staticRenderFns } from "./labelLists.vue?vue&type=template&id=426bff3b&scoped=true&"
import script from "./labelLists.vue?vue&type=script&lang=js&"
export * from "./labelLists.vue?vue&type=script&lang=js&"
import style0 from "./labelLists.vue?vue&type=style&index=0&id=426bff3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426bff3b",
  null
  
)

export default component.exports